import { useState } from 'react';
import { KeyRound, ShieldCheck } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { Button, Card } from '../components/ui';
import './SettingsPage.css';

export function SettingsPage() {
  const { passkeyRegistrationAvailable, registerPasskey } = useAuth();
  const [creating, setCreating] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function createPasskey() {
    setCreating(true);
    setMessage(null);
    setError(null);
    try {
      await registerPasskey();
      setMessage('Passkey created. You can use it the next time you sign in.');
    } catch {
      setError('Passkey creation was not completed. Please try again.');
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="settings-page">
      <div className="settings-heading">
        <h1>Settings</h1>
        <p>Manage how you securely access ZoloTalk.</p>
      </div>

      <Card className="settings-card">
        <div className="settings-card-heading">
          <ShieldCheck aria-hidden="true" />
          <div>
            <h2>Security</h2>
            <p>
              Create a passkey protected by your device fingerprint, face unlock, or screen lock.
            </p>
          </div>
        </div>

        <Button
          type="button"
          size="lg"
          loading={creating}
          disabled={!passkeyRegistrationAvailable}
          onClick={() => void createPasskey()}
        >
          <KeyRound size={20} aria-hidden="true" />
          Create passkey
        </Button>

        {!passkeyRegistrationAvailable && (
          <p className="settings-hint">
            Passkey creation is unavailable in this browser. Open ZoloTalk in a passkey-compatible
            browser and try again.
          </p>
        )}
        {message && (
          <p className="settings-success" role="status">
            {message}
          </p>
        )}
        {error && (
          <p className="settings-error" role="alert">
            {error}
          </p>
        )}
      </Card>
    </div>
  );
}
